import home from '@/router/routes/home'
import familiesList from '@/router/routes/familiesList'
import family from '@/router/routes/family'
import notFound from '@/router/routes/notFound'
import familyChoiceForm from '@/router/routes/familyChoiceForm'
import thanks from '@/router/routes/thanks'

export default [...home, familiesList, family, ...notFound, familyChoiceForm, thanks]
